import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useIsAuthenticated } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import logo from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import style from './NavigationBar.module.scss';
import LanguageSwitcher from '../languageSwitcher/LanguageSwitcher';

import { SignInButton } from '../SignInButton';
import { SignOutButton } from '../SignOutButton';
import { useWindowSize } from '../../utils/hooks';

export function NavigationBar() {
  const isAuthenticated = useIsAuthenticated();
  const size = useWindowSize();
  const [t] = useTranslation();

  return (
    <Navbar expand="lg" id={style.public_navbar_nav}>
      <div
        className={size.width > 991 ? style.containerFluid : `container - fluid ${size.width > 575 ? 'px-2' : 'px-4'}`}
      >
        <Nav.Link as={Link} to={isAuthenticated ? '/dashboard' : '/'}>
          <img alt="logo" height="50" src={logo} />
        </Nav.Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav className={`me-auto ${style.navbar_nav} ${style.nav_styles}`}>
            <Nav.Link as={Link} to="/jobs">
              {t('common.header.menu.jobs')}
            </Nav.Link>
          </Nav>
          <Nav className={`justify-content-end align-items-center ${style.right_side}`}>
            <div className={`me-4 ${style.language_switcher}`}>
              <LanguageSwitcher />
            </div>
            <div className={style.logIn_logOut}>{isAuthenticated ? <SignOutButton /> : <SignInButton />}</div>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}
